import React, { useState, useEffect, useRef } from 'react';
import { useAuth } from '../../context/AuthContext';
import DataTable from 'react-data-table-component';
import { FaUserFriends, FaSearch, FaPlus } from 'react-icons/fa';
import { MdAdd, MdDelete, MdEdit, MdClose } from 'react-icons/md';
import styles from "./companies.module.css";
import { IoCloseSharp } from "react-icons/io5";
import Swal from 'sweetalert2';
import { api } from '../../utils/services/api';
import { APP_OPTIONS, SERVICE } from '../../utils/constants/services';
import Select from 'react-select'
import { Accordion, Card, useAccordionButton } from "react-bootstrap";

export default function ModalCompanies(props) {
    const { show, setShow, ofices, dataEdit, setDataEdit, handleUpdate, estados, municipios } = props;
    const [name, setName] = useState("");
    const [description, setDescription] = useState("");

    const [nameA, setNameA] = useState("");
    const [memberA, setMemberA] = useState("");
    const [descriptionA, setDescriptionA] = useState("");

    const [sucursalSelect, setSucursalSelect] = useState(null);
    const [menuActive, setMenuActive] = useState("menu01");

    const [stateSelect, setStateSelect] = useState(null);
    const [municipalFilter, setMunicipalFilter] = useState([]);
    const [companiesAll, setCompaniesAll] = useState([]);
    const [companiesAsig, setCompaniesAsig] = useState([]);
    const [municipalSelect, setMunicipalSelect] = useState(null);
    const [sucursalesAgregadas, setSucursalesAgregadas] = useState([]);
    const [empresasAfil, setEmpresasAfil] = useState([]);
    const [empresasAsig, setEmpresasAsig] = useState([]);
    const [asignar, setAsignar] = useState(false);
    const { setMenuActual } = useAuth();
    const [loadingTable, setLoadingTable] = useState(false);
    const [totalRows, setTotalRows] = useState(10);
    const [page, setPage] = useState(1);
    const [perPage, setPerPage] = useState(10);
    const [textSearch, setTextSearch] = useState("");
    const [textSearchPrev, setTextSearchPrev] = useState("");

    const columns1 = [

        {
            name: 'Empresa',
            selector: row => row.name,
        },
        {
            name: 'Membresía',
            selector: row => row.membershipNumber,
        },
        // {
        //     name: 'Acciones',
        //     cell: (row) => {
        //         return (
        //             <div style={{ display: "flex" }}>
        //                 <button className='btn btn-sm btn-primary'><MdAdd /></button>&nbsp;
        //             </div>
        //         )
        //     },
        // }
    ];
    const columns3 = [
        {
            name: '#',
            selector: row => row.number,
            cell: (row) => {
                return (
                    <div style={{ display: "flex" }}>
                        {row.number}<span style={{ marginLeft: "10px", display: row.id != 0 ? "none" : "" }} className="badge bg-primary">Nueva</span>
                    </div>
                )
            },
        },
        {
            name: 'Sucursal',
            selector: row => row.nameSucursal,
        },
        {
            name: 'Descripción',
            selector: row => row.descriptionAddress,
        },
        {
            name: 'Acciones',
            cell: (row) => {
                return (
                    <div style={{ display: "flex" }}>
                        <button className='btn btn-sm btn-danger' onClick={() => handleDeletesuc(row.id, row.number)}><MdDelete /></button>&nbsp;
                    </div>
                )
            },
        }
    ];
    const columns2 = [
        {
            name: "",
            cell: (row) => {
                return (
                    <div style={{ display: "flex" }}>
                        <button className='btn btn-sm btn-danger' onClick={() => handleDeletesucasig(row.idAsig, row.number)}><MdDelete></MdDelete></button>
                    </div>
                )
            },
            width: "50px"
        },
        {
            name: '#',
            selector: row => row.number,
            cell: (row) => {
                return (
                    <div style={{ display: "flex" }}>
                        {row.number}<span style={{ marginLeft: "10px", display: row.idAsig != 0 ? "none" : "" }} className="badge bg-primary">Nueva</span>
                    </div>
                )
            },
        },
        {
            name: 'Estado',
            selector: row => row.stateName,
        },
        {
            name: 'Municipio',
            selector: row => row.municipalityName,
        },
        {
            name: 'Descripcion',
            selector: row => row.description,
        },

        // {
        //     name: 'Acciones',
        //     cell: (row) => {
        //         return (
        //             <div style={{ display: "flex" }}>
        //                 <button className='btn btn-sm btn-primary'><MdAdd /></button>&nbsp;
        //             </div>
        //         )
        //     },
        // }
    ];
    const handleDeletesuc = (id, number) => {
        if (id === 0) {
            let array = [];
            let cont = 1;
            for (let index = 0; index < sucursalesAgregadas.length; index++) {
                const element = sucursalesAgregadas[index];
                if (element.number != number) {
                    array.push({ ...element, number: cont });
                    cont = cont + 1;
                }

            }
            setSucursalesAgregadas(array);
        }
        else {
            Swal.fire({
                title: "¿Esta segur@ que desea eliminar la sucursal?",
                showCancelButton: true,
                confirmButtonText: "Eliminar",
                denyButtonText: "Cancelar"
            }).then((result) => {
                if (result.isConfirmed) {
                    api(SERVICE.deleteCompanieSuc + `?id=${id}`, {}, "DELETE")
                        .then((data) => {
                            let array = [];
                            let cont = 1;
                            for (let index = 0; index < sucursalesAgregadas.length; index++) {
                                const element = sucursalesAgregadas[index];
                                if (element.number != number) {
                                    array.push({ ...element, number: cont });
                                    cont = cont + 1;
                                }
                            }
                            setSucursalesAgregadas(array);
                            handleUpdate();
                        })
                        .catch((err) => {
                            console.log(err);
                        })
                }
            });
        }
    }
    const handleDeletesucasig = (id, number) => {
        if (id === 0) {
            let arrayT = [];
            let cont = 1;
            for (let index = 0; index < empresasAsig.length; index++) {
                const element = empresasAsig[index];
                if (element.number != number) {
                    arrayT.push({ ...element, number: cont });
                    cont++;
                }
            }
            setEmpresasAsig(arrayT);
        }
        else {
            Swal.fire({
                title: "¿Esta segur@ que desea eliminar la sucursal asignada?",
                showCancelButton: true,
                confirmButtonText: "Eliminar",
                denyButtonText: "Cancelar"
            }).then((result) => {
                if (result.isConfirmed) {
                    api(SERVICE.deleteCompaniesAsig + id, {}, "DELETE")
                        .then((data) => {
                            let arrayT = [];
                            let cont = 1;
                            for (let index = 0; index < empresasAsig.length; index++) {
                                const element = empresasAsig[index];
                                if (element.number != number) {
                                    arrayT.push({ ...element, number: cont });
                                    cont++;
                                }
                            }
                            setEmpresasAsig(arrayT);
                            handleUpdate();
                        })
                        .catch((err) => {
                            console.log(err);
                        })
                }
            });
        }
    }

    const handleAgregarSucursal = async () => {
        if (sucursalSelect === null || description === "") {
            Swal.fire({
                text: 'Favor de llenar todos los campos',
                icon: 'error',
                confirmButtonText: 'Aceptar'
            })

        }
        else {
            if (dataEdit != null) {
                let companyId = dataEdit.id;
                let payload = {

                    CompanyId: companyId,
                    DescriptionAddress: description,
                    CentralOfficesId: sucursalSelect.value
                }
                await api(SERVICE.setCompanieSuc, payload, "POST")
                    .then((data) => {
                        let idSucursal = data.data.data;
                        let arrayTemp = [...sucursalesAgregadas];
                        arrayTemp.push({
                            id: idSucursal,
                            number: (arrayTemp.length + 1),
                            nameSucursal: sucursalSelect.label,
                            idSucursal: sucursalSelect.value,
                            descriptionAddress: description
                        });
                        setDescription("");
                        setSucursalSelect(null);
                        setSucursalesAgregadas(arrayTemp);
                        handleUpdate();
                        Swal.fire({
                            position: "center",
                            icon: "success",
                            title: "Sucursal agregada",
                            showConfirmButton: false,
                            timer: 1500
                        });
                    })
                    .catch((err) => {
                        console.log(err);
                    })
            }
            else {
                let arrayTemp = [...sucursalesAgregadas];
                arrayTemp.push({
                    id: 0,
                    number: (arrayTemp.length + 1),
                    nameSucursal: sucursalSelect.label,
                    idSucursal: sucursalSelect.value,
                    descriptionAddress: description
                });
                setDescription("");
                setSucursalSelect(null);
                setSucursalesAgregadas(arrayTemp);
                Swal.fire({
                    position: "center",
                    icon: "success",
                    title: "Sucursal agregada",
                    showConfirmButton: false,
                    timer: 1500
                });
            }

        }
    }
    const handleUpdateAF = async () => {
        let URL = SERVICE.getCompanieAfGrid + `?TypeSearch=1&Page=${page}&PageSize=${perPage}`;
        if (textSearch != "") {
            URL = URL + `&TextSearch=${textSearch}`;
        }
        setTextSearchPrev(textSearch);
        setTextSearch("");
        await api(URL)
            .then(async (data) => {
                let arrayTemp = [];
                if (data.data.data) {
                    for (let index = 0; index < data.data.data.length; index++) {
                        if (data && data.data && data.data.paginationInfo) {
                            setTotalRows(data.data.paginationInfo.totalRecords);
                        }
                        const element = data.data.data[index];
                        let arraySuc = [];
                        await api(SERVICE.getCompanieSucAf + element.id)
                            .then((data) => {

                                if (data.data.data) {
                                    for (let index = 0; index < data.data.data.length; index++) {
                                        const sucursalCom = data.data.data[index];
                                        arraySuc.push({
                                            ...sucursalCom
                                        });
                                    }
                                }
                            })
                            .catch((err) => {
                                console.log(err);
                            })
                        arrayTemp.push({
                            ...element,
                            sucursales: arraySuc
                        });

                    }
                }
                setEmpresasAfil(arrayTemp);
                if (dataEdit != null) {
                    handleGetCompaniesAdd(arrayTemp);
                }
            })
            .catch((err) => {
                console.log(err);
            })
    }
    const handleUpdateAFNosearch = async () => {
        let URL = SERVICE.getCompanieAfGrid + `?TypeSearch=1&Page=${page}&PageSize=${perPage}`;
        await api(URL)
            .then(async (data) => {
                let arrayTemp = [];
                if (data.data.data) {
                    for (let index = 0; index < data.data.data.length; index++) {
                        if (data && data.data && data.data.paginationInfo) {
                            setTotalRows(data.data.paginationInfo.totalRecords);
                        }
                        const element = data.data.data[index];
                        let arraySuc = [];
                        await api(SERVICE.getCompanieSucAf + element.id)
                            .then((data) => {

                                if (data.data.data) {
                                    for (let index = 0; index < data.data.data.length; index++) {
                                        const sucursalCom = data.data.data[index];
                                        arraySuc.push({
                                            ...sucursalCom
                                        });
                                    }
                                }
                            })
                            .catch((err) => {
                                console.log(err);
                            })
                        arrayTemp.push({
                            ...element,
                            sucursales: arraySuc
                        });

                    }
                }
                setEmpresasAfil(arrayTemp);
                if (dataEdit != null) {
                    handleGetCompaniesAdd(arrayTemp);
                }
            })
            .catch((err) => {
                console.log(err);
            })
    }
    const handleAgregar = async () => {
        if (name === "") {
            Swal.fire({
                text: 'Favor de llenar todos los campos',
                icon: 'error',
                confirmButtonText: 'Aceptar'
            })
        }
        else {
            if (dataEdit != null) {
                let companyId = dataEdit.id;
                let companyOfId = 0;
                let payload = {
                    Id: dataEdit.id,
                    CompanyName: name
                }
                await api(SERVICE.updateCompanie, payload, "PUT")
                    .then((data) => {
                        //companyId = data.data.data;
                    })
                    .catch((err) => {
                        console.log(err);
                    })
                if (companyId != 0) {
                    if (sucursalesAgregadas.length > 0) {
                        for (let index = 0; index < sucursalesAgregadas.length; index++) {
                            const element = sucursalesAgregadas[index];
                            let payload = {
                                Id: element.id,
                                CompanyId: companyId,
                                DescriptionAddress: element.descriptionAddress,
                                CentralOfficesId: element.idSucursal
                            }
                            if (element.id === 0) {
                                await api(SERVICE.setCompanieSuc, payload, "POST")
                                    .then((data) => {
                                        companyOfId = data.data.data;
                                    })
                                    .catch((err) => {
                                        console.log(err);
                                    })
                            }

                        }
                    }
                    if (empresasAsig.length > 0) {
                        for (let index = 0; index < empresasAsig.length; index++) {
                            const element = empresasAsig[index];
                            if (element.idAsig == 0) {
                                let payload = {
                                    CompanyId: companyId,
                                    AffiliatedCompanyCentralOfficeId: element.id
                                }
                                await api(SERVICE.setCompaniesAsig, payload, "POST")
                                    .then((data) => {
                                        //companyOfId = data.data.data;
                                    })
                                    .catch((err) => {
                                        console.log(err);
                                    })
                            }
                        }
                    }

                }
                handleUpdate();
                setShow(false);
                Swal.fire({
                    position: "center",
                    icon: "success",
                    title: "Guardado correctamente",
                    showConfirmButton: false,
                    timer: 1500
                });
            }
            else {
                let companyId = 0;
                let companyOfId = 0;
                let payload = {
                    CompanyName: name
                }
                await api(SERVICE.setCompanie, payload, "POST")
                    .then((data) => {
                        companyId = data.data.data;
                    })
                    .catch((err) => {
                        console.log(err);
                    })
                if (companyId != 0) {
                    if (sucursalesAgregadas.length > 0) {
                        for (let index = 0; index < sucursalesAgregadas.length; index++) {
                            const element = sucursalesAgregadas[index];
                            let payload = {
                                CompanyId: companyId,
                                Description: element.description,
                                CentralOfficesId: element.idSucursal
                            }
                            await api(SERVICE.setCompanieSuc, payload, "POST")
                                .then((data) => {
                                    companyOfId = data.data.data;
                                })
                                .catch((err) => {
                                    console.log(err);
                                })
                        }
                    }

                }
                handleUpdate();
                setShow(false);
                Swal.fire({
                    position: "center",
                    icon: "success",
                    title: "Guardado correctamente",
                    showConfirmButton: false,
                    timer: 1500
                });
            }

        }

    }
    const handleGetCompaniesAf = () => {
        api(SERVICE.getCompaniesAf)
            .then(async (data) => {
                if (data.data.data) {
                    const promises = data.data.data.map(async (companieMain) => {
                        const response = await api(SERVICE.getCompaniesAfSuc + companieMain.id);
                        return response.data.data.map((dataComplement) => ({
                            id: dataComplement.affiliatedCompanyId,
                            name: companieMain.name,
                            member: companieMain.membershipNumber,
                            location: `${dataComplement.stateName} - ${dataComplement.municipalityName}`,
                        }));
                    });

                    const results = await Promise.all(promises);
                    setCompaniesAll(results.flat()); // <- Una sola actualización
                }
            })
            .catch((err) => console.log(err));
    };
    const handleGetCompaniesAdd = (empresasAfilTemp) => {
        api(SERVICE.getCompaniesAsig)
            .then(async (data) => {
                if (data.data.data) {
                    let info = data.data.data;
                    let arrayTemp = [];
                    let cont = 1;
                    for (let index = 0; index < info.length; index++) {
                        const element = info[index];
                        if (element.companyId === dataEdit.id) {


                            for (let index2 = 0; index2 < empresasAfilTemp.length; index2++) {
                                const empresa = empresasAfilTemp[index2];
                                let searchIn = empresa.sucursales.findIndex(item => item.id === element.affiliatedCompanyCentralOfficeId);
                                if (searchIn !== -1) {
                                    arrayTemp.push({ ...empresa.sucursales[searchIn], number: cont, idAsig: element.id });
                                    cont = cont + 1;
                                }
                            }
                        }
                    }
                    setEmpresasAsig(arrayTemp);
                }
            })
            .catch((err) => console.log(err));
    };

    const handleAgregarAf = async () => {
        if (nameA === "" || descriptionA === "" || memberA === "" || stateSelect === null || municipalSelect === null) {
            Swal.fire({
                text: 'Favor de llenar todos los campos',
                icon: 'error',
                confirmButtonText: 'Aceptar'
            })
        }
        else {
            if (dataEdit != null) {

            }
            else {
                let companyId = 0;
                let companyOfId = 0;
                let payload = {
                    Name: nameA,
                    MembershipNumber: memberA
                }
                await api(SERVICE.setCompanieAf, payload, "POST")
                    .then((data) => {
                        companyId = data.data.data;
                    })
                    .catch((err) => {
                        console.log(err);
                    })
                if (companyId != 0) {
                    let payload = {
                        AffiliatedCompanyId: companyId,
                        Description: descriptionA,
                        StateId: stateSelect.value,
                        MunicipalityId: municipalSelect.value
                    }
                    await api(SERVICE.setCompanieAfSuc, payload, "POST")
                        .then((data) => {
                            companyOfId = data.data.data;
                        })
                        .catch((err) => {
                            console.log(err);
                        })
                }
                Swal.fire({
                    position: "center",
                    icon: "success",
                    title: "Guardado correctamente",
                    showConfirmButton: false,
                    timer: 1500
                });
            }

        }

    }

    useEffect(() => {

    }, [])
    useEffect(() => {
        if (empresasAsig) {
            let arrayTemp = [...empresasAfil];
            for (let index = 0; index < arrayTemp.length; index++) {
                const empresa = arrayTemp[index];
                for (let index2 = 0; index2 < empresa.sucursales.length; index2++) {
                    const sucursal = empresa.sucursales[index2];
                    let search = empresasAsig.findIndex(item => item.id === sucursal.id);
                    arrayTemp[index].sucursales[index2].asignado = search !== -1;
                }
            }
            setEmpresasAfil(arrayTemp);
        }
    }, [empresasAsig])
    useEffect(() => {
        if (dataEdit != null && show) {
            setName(dataEdit.companyName);
            let array = [];
            if (dataEdit.sucursales) {
                for (let index = 0; index < dataEdit.sucursales.length; index++) {
                    const element = dataEdit.sucursales[index];
                    array.push({
                        id: element.id,
                        number: (index + 1),
                        nameSucursal: element.centralOfficeName,
                        idSucursal: element.centralOfficesId,
                        descriptionAddress: element.descriptionAddress
                    })
                }
            }

            setSucursalesAgregadas(array);
        }
    }, [dataEdit, show])

    useEffect(() => {
        if (!show) {
            setDataEdit(null);
            setName("");
            setEmpresasAsig([]);
            setEmpresasAfil([]);
            setSucursalSelect(null);
            setDescription("");
            setSucursalesAgregadas([]);
            setAsignar(false);
            setMenuActive("menu01")
        }
        else {
            handleUpdateAF();
        }
    }, [show])
    const handlePageChange = (newPage) => {
        setPage(newPage);
    };

    const handlePerRowsChange = (newPerPage) => {
        setPerPage(newPerPage);
    };
    useEffect(() => {
        handleUpdateAF();
    }, [page, perPage])
    useEffect(() => {
        console.log("companiesAll", companiesAll)
    }, [companiesAll])
    useEffect(() => {
        if (stateSelect != null && municipios && municipios.length > 0) {
            setMunicipalSelect(null);
            let ArrayTemp = [];
            for (let index = 0; index < municipios.length; index++) {
                const element = municipios[index];
                if (element.stateId === stateSelect.value) {
                    ArrayTemp.push(element);
                }

            }
            setMunicipalFilter(ArrayTemp);
        }
    }, [stateSelect, municipios])
    const ExpandedComponentSucursales = ({ data }) => {
        console.log("data", data);
        let array = [];
        if (data && data.sucursales && data.sucursales.length > 0) {
            for (let index = 0; index < data.sucursales.length; index++) {
                const element = data.sucursales[index];
                array.push(
                    <tr>
                        <td>{index + 1}</td>
                        <td>{element.stateName}</td>
                        <td>{element.municipalityName}</td>
                        <td>{element.description}</td>
                        <td>
                            <button style={{ display: element.asignado ? "none" : "" }} className="btn btn-sm btn-success" onClick={() => {
                                if (dataEdit != null) {
                                    let companyId = dataEdit.id;
                                    let payload = {
                                        CompanyId: companyId,
                                        AffiliatedCompanyCentralOfficeId: element.id
                                    }
                                    api(SERVICE.setCompaniesAsig, payload, "POST")
                                        .then((data) => {
                                            let idAsig = data.data.data;
                                            let arrayT = [...empresasAsig];
                                            arrayT.push({ ...element, idAsig: idAsig, number: (arrayT.length + 1) });
                                            setEmpresasAsig(arrayT);
                                            handleUpdate();

                                        })
                                        .catch((err) => {
                                            console.log(err);
                                        })

                                }
                                else {
                                    let arrayT = [...empresasAsig];
                                    arrayT.push({ ...element, idAsig: 0, number: (arrayT.length + 1) });
                                    setEmpresasAsig(arrayT);
                                }

                            }}>Asignar</button>
                            <span style={{ display: element.asignado ? "" : "none" }} className="badge bg-primary">asignada</span>
                            <button onClick={() => {
                                let search = empresasAsig.findIndex(item => item.id === element.id);
                                if (search !== -1) {
                                    handleDeletesucasig(empresasAsig[search].idAsig, empresasAsig[search].number);
                                }
                            }} style={{ display: element.asignado ? "" : "none", marginLeft: "20px" }} className="btn btn-sm btn-danger"><MdDelete></MdDelete></button>
                        </td>

                    </tr>
                );
            }
        }
        return (
            <div style={{ paddingLeft: "50px" }}>
                <div style={{ display: array.length > 0 ? "flex" : "none", justifyContent: "center", alignItems: "center", backgroundColor: "#69A3C3", color: "white" }}>Sucursales</div>
                <table class="table table-light" >
                    <tbody style={{ fontSize: "14px" }}>
                        {array}
                    </tbody>
                </table>
            </div>

        );
    };

    const alwaysExpanded = (row) => true;

    return (
        <>
            <div className={styles.bodyModal} style={{ display: show ? "" : "none" }}>
                <div className={`${styles.containerFormMain} animate__animated animate__fadeInDown`} style={{ display: show ? "" : "none" }}>
                    <div className={styles.headerForm}>
                        <h5>{dataEdit != null ? "Editar Empresa" : "Nueva Empresa"}</h5>
                        <div className={styles.icon} onClick={() => setShow(false)}>
                            <IoCloseSharp />
                        </div>

                    </div>
                    <div className={styles.containerTabs} >
                        <ul class="nav nav-tabs">
                            <li className={menuActive == "menu01" ? "nav-item-active" : "nav-item"} onClick={() => setMenuActive("menu01")}>
                                <a className={menuActive == "menu01" ? "nav-link active" : "nav-link"}>Empresa</a>
                            </li>
                            <li className={menuActive == "menu02" ? "nav-item-active" : "nav-item"} onClick={() => setMenuActive("menu02")}>
                                <a className={menuActive == "menu02" ? "nav-link active" : "nav-link"}>Asignar Empresas Afiliadas</a>
                            </li>
                        </ul>
                    </div>
                    <div className={styles.containerForm} style={{ display: menuActive == "menu01" ? "flex" : "none" }}>
                        <div className={styles.itemForm}>
                            <label class="form-label">Nombre empresa:</label>
                            <input type="text" class="form-control" placeholder="Nombre empresa" value={name} onChange={(e) => setName(e.target.value)} />
                        </div>
                        <div className={styles.itemForm} style={{ width: "100%" }}>
                            <Accordion>
                                <Accordion.Item eventKey="0">
                                    <Accordion.Header>Agregar sucursales</Accordion.Header>
                                    <Accordion.Body>
                                        <div className={styles.containerForm} style={{ display: "flex" }}>
                                            <div className={styles.itemForm}>
                                                <label class="form-label">Sucursal*:</label>
                                                <Select placeholder="Selecciona una sucursal" options={ofices} class="form-control" value={sucursalSelect} onChange={(e) => setSucursalSelect(e)} />
                                            </div>
                                            <div className={styles.itemForm}>
                                                <label class="form-label">Descripcion*:</label>
                                                <input type="text" class="form-control" placeholder="Descripcion" value={description} onChange={(e) => setDescription(e.target.value)} />
                                            </div>
                                            <div className={styles.itemForm} style={{ width: "100%" }}>
                                                <button className='btn btn-success' onClick={() => handleAgregarSucursal()}>Agregar</button>&nbsp;&nbsp;
                                            </div>
                                        </div>
                                    </Accordion.Body>
                                </Accordion.Item>

                            </Accordion>

                        </div>

                        <div className={styles.itemForm} style={{ width: "100%", borderStyle: "solid", borderWidth: "0px 0px 1px 0px" }}>
                            <h5>Sucursales Agregadas</h5>
                            <DataTable
                                columns={columns3}
                                data={sucursalesAgregadas}
                                customStyles={APP_OPTIONS.TABLE_SETTING}
                                pagination
                                persistTableHead
                            />
                        </div>
                    </div>
                    <div className={styles.containerForm} style={{ display: menuActive == "menu02" ? "flex" : "none" }}>
                        <div className={styles.itemForm} style={{ width: "100%", display: "none" }}>
                            <button className={asignar ? 'btn btn-danger' : 'btn btn-primary'} onClick={() => setAsignar(!asignar)}>{asignar ? "Ocultar más sucursales" : "Asignar más sucursales"}</button>
                            <hr>
                            </hr>
                        </div>
                        <div className={styles.itemForm} style={{ width: "100%" }}>

                            {/* <h6>Empresas afiliadas <button className='btn btn-sm btn-primary' onClick={() => {
                                Swal.fire({
                                    title: "¿Esta segur@? se enviará al módulo de Empresas Afiliadas",
                                    showCancelButton: true,
                                    confirmButtonText: "Aceptar",
                                    cancelButtonText: "Cancelar"
                                }).then((result) => {
                                    if (result.isConfirmed) {   
                                        setMenuActual("catalog6");
                                    }
                                });
                            }}>Crear empresas afiliadas</button></h6> */}
                            <div class="input-group flex-nowrap" style={{ marginBottom: "10px", width: "100%" }}>
                                <input type="text" class="form-control" placeholder="Busqueda" value={textSearch} onChange={(e) => setTextSearch(e.target.value)} aria-describedby="addon-wrapping" />
                                <button className='btn btn-primary' onClick={handleUpdateAF}><FaSearch /></button>
                            </div>
                            <div class="input-group flex-nowrap containerSearchPrev" style={{ display: textSearchPrev !== "" ? "flex" : "none" }}>
                                <div class="badgeSearch">Buscando por: <b>{textSearchPrev}</b> </div><div onClick={() => {
                                    setTextSearch("");
                                    setTextSearchPrev("");
                                    handleUpdateAFNosearch();
                                }} className='divCloseSearch'><MdClose></MdClose></div>
                            </div>
                            <div className='labelTable'>
                                <div>Empresas afiliadas</div>&nbsp;&nbsp;&nbsp;
                                <button className='btn btn-sm btn-success' onClick={() => {
                                    Swal.fire({
                                        title: "¿Esta segur@? se enviará al módulo de Empresas Afiliadas",
                                        showCancelButton: true,
                                        confirmButtonText: "Aceptar",
                                        cancelButtonText: "Cancelar"
                                    }).then((result) => {
                                        if (result.isConfirmed) {
                                            setMenuActual("catalog6");
                                        }
                                    });
                                }}>Crear nueva</button>
                            </div>
                            <DataTable
                                columns={columns1}
                                data={empresasAfil}
                                customStyles={APP_OPTIONS.TABLE_SETTING}
                                pagination
                                paginationServer
                                paginationTotalRows={totalRows}
                                paginationPerPage={perPage}
                                paginationRowsPerPageOptions={[10, 20, 30, 50]}
                                onChangePage={handlePageChange}
                                onChangeRowsPerPage={handlePerRowsChange}
                                progressPending={loadingTable}
                                persistTableHead
                                fixedHeader
                                fixedHeaderScrollHeight="600px"
                                responsive
                                expandableRows
                                expandableRowsComponent={ExpandedComponentSucursales}
                                expandableRowExpanded={alwaysExpanded}
                            />
                        </div>
                        <div className={styles.itemForm} style={{ display: "none" }}>

                            <div className='labelTable'>
                                <div>Empresas asigandas</div>
                            </div>
                            <DataTable
                                columns={columns2}
                                data={empresasAsig}
                                customStyles={APP_OPTIONS.TABLE_SETTING}
                                pagination
                                persistTableHead
                            />
                        </div>

                    </div>
                    <div className={styles.containerBtn}>
                        <button className='btn btn-success' onClick={() => handleAgregar()}>{dataEdit != null ? "Editar" : "Crear"}</button>&nbsp;&nbsp;
                        <button className='btn btn-danger' onClick={() => setShow(false)}>Cancelar</button>
                    </div>
                </div>
            </div>
        </>
    );
}